// RecoverCann Cannabis-Specific JavaScript
// Handles dynamic THC cap warnings based on product THC level tier (0-4 scale)
// THC levels: 1=THC Free, 1.5=CBD Dominant, 2=Balanced, 3=THC Friendly, 4=None (most permissive)
// Customer thcCap restricts: product.thcLevel must be <= customer.thcCap

class RecoverCannThemeApp {
  constructor() {
    this.customerThcCap = this.getCustomerThcCap();
    this.productThcLevel = this.getProductThcLevel();
    this.levelNames = { 1: 'THC Free', 1.5: 'CBD Dominant', 2: 'Balanced', 3: 'THC Friendly', 4: 'None (Unrestricted)' };
    this.init();
  }

  init() {
    // Initialize on page load
    document.addEventListener('DOMContentLoaded', () => {
      this.checkThcRestriction();
    });

    // Re-check when variant changes
    document.addEventListener('variant:update', () => {
      this.checkThcRestriction();
    });
  }

  getCustomerThcCap() {
    // Get from meta tag in layout (set from recovercann.thc_cap metafield)
    const metaTag = document.querySelector('meta[name="customer-thc-cap"]');
    return metaTag ? parseFloat(metaTag.content) : null;
  }

  getProductThcLevel() {
    // Prefer product form data attribute (per-product scope)
    const form = document.querySelector('product-form-component[data-product-thc-level]');
    if (form && form.dataset.productThcLevel) {
      return parseFloat(form.dataset.productThcLevel);
    }

    // Fallback: look for meta tag
    const metaTag = document.querySelector('meta[name="product-thc-level"]');
    if (metaTag) return parseFloat(metaTag.content);

    // Fallback: look for any data attribute
    const el = document.querySelector('[data-product-thc-level]');
    if (el) return parseFloat(el.dataset.productThcLevel);

    return null;
  }

  checkThcRestriction() {
    if (!this.customerThcCap || this.customerThcCap <= 0) return;

    // No THC level on product means no restriction applies
    if (!this.productThcLevel) {
      this.updateWarningDisplay(false, null);
      this.updateAddToCartButton(false);
      return;
    }

    const exceedsCap = this.productThcLevel > this.customerThcCap;
    this.updateWarningDisplay(exceedsCap, this.productThcLevel);
    this.updateAddToCartButton(exceedsCap);
  }

  updateWarningDisplay(exceedsCap, productLevel) {
    const warningContainers = document.querySelectorAll('.product-thc-warning');
    if (!warningContainers.length) return;

    warningContainers.forEach((warningContainer) => {
      if (exceedsCap) {
        warningContainer.style.display = 'flex';
        warningContainer.setAttribute('aria-hidden', 'false');
        this.updateWarningMessage(productLevel);
      } else {
        warningContainer.style.display = 'none';
        warningContainer.setAttribute('aria-hidden', 'true');
      }
    });
  }

  updateWarningMessage(productLevel) {
    const messageElement = document.querySelector('.product-thc-warning__message');
    if (!messageElement) return;

    const productLevelName = this.levelNames[productLevel] || `Level ${productLevel}`;
    const capLevelName = this.levelNames[this.customerThcCap] || `Level ${this.customerThcCap}`;
    const message = `This product's THC level is "${productLevelName}", which exceeds your THC cap of "${capLevelName}". Please remove this product from your cart or contact support if you need assistance.`;
    messageElement.textContent = message;
  }

  updateAddToCartButton(exceedsCap) {
    const formComponent = document.querySelector('product-form-component');
    const addToCartButton = formComponent?.querySelector('[name="add"]');
    
    if (!addToCartButton) return;

    if (exceedsCap) {
      // Disable button
      addToCartButton.disabled = true;
      addToCartButton.setAttribute('aria-disabled', 'true');

      // Add visual class
      formComponent?.classList.add('product-form--restricted');
    } else {
      // Enable button
      addToCartButton.disabled = false;
      addToCartButton.setAttribute('aria-disabled', 'false');

      // Remove visual class
      formComponent?.classList.remove('product-form--restricted');
    }
  }
}

// Initialize the app
new RecoverCannThemeApp();
